import { render, staticRenderFns } from "./MtPriceTemplates.vue?vue&type=template&id=2e213f12&scoped=true&"
import script from "./MtPriceTemplates.vue?vue&type=script&lang=js&"
export * from "./MtPriceTemplates.vue?vue&type=script&lang=js&"
import style0 from "./MtPriceTemplates.vue?vue&type=style&index=0&id=2e213f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e213f12",
  null
  
)

export default component.exports